<template>
    <div class="footer cont">
        <div class="uni-footer">
            <p>
                <a target="_blank" href="http://corp.sina.com.cn/chn/">新浪简介</a> |
                <a target="_blank" href="http://corp.sina.com.cn/eng/">About Sina</a> |
                <a target="_blank" href="http://emarketing.sina.com.cn/">广告服务</a> |
                <a target="_blank" href="http://corp.sina.com.cn/chn/sina_job.html">招聘信息</a> |
                <a target="_blank" href="http://www.sina.com.cn/intro/lawfirm.shtml">网站律师</a> |
                <a target="_blank" href="http://english.sina.com">SINA English</a> |
                <a target="_blank" href="https://login.sina.com.cn/signup/signup.php">通行证注册</a> |
                <a target="_blank" href="http://tech.sina.com.cn/focus/sinahelp.shtml">产品答疑</a>
            </p>
            <p>Copyright &#169; 1996 - 2020 SINA Corporation, All Rights Reserved</p>
            <p>
                新浪公司
                <a target="_blank" href="http://www.sina.com.cn/intro/copyright.shtml">版权所有</a>
            </p>
        </div>
    </div>
</template>
<script>
export default {
    name: "foot",
    data() {
        return {

        }
    }
};
</script>